import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminFaqComponent } from './admin-faq.component';
import { FaqComponent } from './faq/faq.component';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';



@NgModule({
  declarations: [AdminFaqComponent, FaqComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    AppRoutingModule,
    CKEditorModule
  ],
  exports: [AdminFaqComponent, FaqComponent]
})
export class AdminFaqModule { }
